import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { findValidDelivery } from 'Redux/ducks/deliveries';
import Terms from 'Components/Vouchers/Terms';

import 'Components/Account/AccountModal.scss';
import 'Components/Product/ProductOffers/VoucherDelivery.scss';

const VoucherDelivery = ({ deliveries, product }) => {
  const [openModal, setOpenModal] = useState(false);

  if (!product) {
    return false;
  }

  const delivery = findValidDelivery(product, deliveries);

  if (!delivery) return false;

  let subtitle = '';
  if (delivery.did && delivery.did.name) {
    subtitle = delivery.subtitle;
  }

  return (
    <React.Fragment>
      <div className="voucher-delivery-banner">
        <div className="circle-start" />
        <div className="percent-container">
          <div className="percent-number">
            {delivery.percent}
          </div>
          <div className="percent-symbol-container">
            <div className="percent-symbol">
              %
            </div>
            <div className="percent-off">
              off
            </div>
          </div>
        </div>
        <div className="description-container">
          <div className="description-text-container">
            <div className="description-heading">
              {delivery.percent}
              %
              {' '}
              <FormattedMessage
                id="VoucherDeliveryBanner.offnextOrder"
                defaultMessage="off your next order"
              />&nbsp;
              {subtitle &&
                <span>
                  {subtitle}
                </span>
              }
            </div>
            <div className="description-subheading">
              <FormattedMessage
                id="VoucherDeliveryBanner.emailedToYou"
                defaultMessage="Get a coupon via email with purchase. Exclusions apply"
              />
            </div>
          </div>
          <button
            className="description-button"
            onClick={() => setOpenModal(!openModal)}
          >
            <div className="description-button-text">
              <FormattedMessage
                id="VoucherDeliveryBanner.button-text"
                defaultMessage="Learn More"
              />
            </div>
          </button>
        </div>
        <div className="circle-end" />
      </div>

      <Modal isOpen={openModal} toggle={() => setOpenModal(!openModal)} className="account-modal account-modal--large">
        <ModalBody>
          <div className="account-modal-title">
            <FormattedMessage
              id="VoucherDeliveryBanner.modal.terms.title"
              defaultMessage="Coupon Qualification Terms and Conditions"
            />
          </div>
          <div className="account-modal-form">
            <p>
              {delivery.description}
            </p>
            <b>
              <FormattedMessage
                id="VoucherDeliveryBanner.modal.terms.sub"
                defaultMessage="To receive this coupon make an order that meets these conditions:"
              />
            </b>
            <Terms isDelivery voucher={delivery} />
          </div>
        </ModalBody>
        <div className="close-button-container">
          <button onClick={() => setOpenModal(!openModal)}>
            <FontAwesomeIcon icon={faXmark} title="Close modal" />
          </button>
        </div>
      </Modal>

    </React.Fragment>
  );
};

VoucherDelivery.propTypes = {
  product: PropTypes.shape({
    slug: PropTypes.string,
  }).isRequired,
  deliveries: PropTypes.arrayOf(PropTypes.shape({})),
};

VoucherDelivery.defaultProps = {
  deliveries: [],
};

const mapStateToProps = ({
  deliveries: { all },
}) => ({ deliveries: all });

export default connect(mapStateToProps, {})(VoucherDelivery);
